var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.60372 4.70376C2.80875 4.49873 3.14116 4.49873 3.34618 4.70376L7.17495 8.53253L11.0037 4.70376C11.2087 4.49873 11.5412 4.49873 11.7462 4.70376C11.9512 4.90878 11.9512 5.24119 11.7462 5.44622L7.54618 9.64622C7.34116 9.85124 7.00875 9.85124 6.80372 9.64622L2.60372 5.44622C2.39869 5.24119 2.39869 4.90878 2.60372 4.70376Z",
    fill: "#47494D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDown);
export default __webpack_public_path__ + "static/media/icon-down.0164df670a274388183da2ceb6bbf1f7.svg";
export { ForwardRef as ReactComponent };